import React from 'react';
import UserDetails from './components/UserDetails';
import Application from './components/Application';
import { Row, Col, Layout, Heading } from 'elmo-elements';
import { ApplicationsProps } from './type';
import {
  ApplicationsHeading,
  Header,
  HeaderLogo,
  LayoutWrapper,
} from './style';
import headerLogoImg from './assets/header-logo.svg';
import VPNSection from './components/VPNSection';

function Applications({ user, apps, isOpenVPNEnabled }: ApplicationsProps) {
  return (
    <Layout>
      <LayoutWrapper>
        <Layout.Content>
          <Header>
            <HeaderLogo src={headerLogoImg} />
            {user && <UserDetails {...user} />}
          </Header>
          <ApplicationsHeading>
            <Heading type="heading" align="center" htmlTag="h4">
              Welcome back,{' '}
              <span data-testid="userName">{user ? user.displayName : ''}</span>
            </Heading>
            {!isOpenVPNEnabled && <VPNSection />}
          </ApplicationsHeading>
          <Row alignContent="center" justifyContent="center">
            {apps &&
              apps.map((app: any, i: number) => (
                <Col key={`${app}-${i}`} lg={6} md={12} sm={12} xs={24}>
                  <Application {...app} />
                </Col>
              ))}
          </Row>
        </Layout.Content>
      </LayoutWrapper>
    </Layout>
  );
}

export default Applications;
